import { isInvalidDateString, parseMonthYearFormat, parseDayMonthYearFormat } from './helpers'

// Парсим дату из DD/MM/YYYY, DD/MM/YYYY, HH:MM или MM/YYYY
export function parseDate(
  dateStr: string,
  monthYearOnly: boolean,
  includeTime: boolean
): Date | null {
  if (isInvalidDateString(dateStr)) return null
  
  // Handle MM/YYYY format (monthYearOnly)
  if (monthYearOnly) {
    return parseMonthYearFormat(dateStr)
  }
  
  // Handle format with time: DD/MM/YYYY, HH:MM
  return parseDayMonthYearFormat(dateStr, includeTime)
}
